import * as React from "react";
import {
  BODetailTopBar,
  BODetailTopBarItem
} from "app/components/BOComponents/BODetailTopBar/BODetailTopBar";
import { groupAuth } from "app/utils/authGroups";

const UserMessageGeneralTopBar = () => {
  return (
    <BODetailTopBar>
      <BODetailTopBarItem
        text="List"
        link={`/snapscan/ops/user_messaging/list`}
      />
      {groupAuth.hasAccessGroup(["Ops/UserMessaging"]) ? (
        <BODetailTopBarItem
          text="Add New"
          link={`/snapscan/ops/user_messaging/new`}
        />
      ) : null}
    </BODetailTopBar>
  );
};

export default UserMessageGeneralTopBar;
